import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ICampusSkill } from '@/src/types/resumeDetail/campusType';

import './index.scss';

interface IProps {
  data: ICampusSkill[];
  setMode: Function;
}

// 仅校招
const SkillStandardView: FC<IProps> = (props) => {
  const { data, setMode } = props;
  const { campusResumeFormRefStore } = useRootStore();

  const storeRef = campusResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('skill_standard_edit');
  };

  return (
    <div className="skill_standard_view model_view">
      <div className="model_title" onClick={() => handleEdit()}>
        <div>技能水平</div>
        <div className="edit_icon">
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_main">
        {data?.map((item) => (
          <div className="model_list" key={item.renderId}>
            <span className="skill_name">
              <span>{item.skillName}</span>
            </span>
            {item?.skillLevelName && <span className="center">|</span>}
            {item?.skillLevelName && (
              <span className="skill_level">
                <span>{item.skillLevelName}</span>
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillStandardView;
